import { apiClient } from '../utils/apiClient';

function publicApiPath(slug) {
  return `/public-apis/${encodeURIComponent(slug)}`;
}

class PublicApiService {
  async getMyListings() {
    try {
      const response = await apiClient.get('/account/public-apis');
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.error ||
          error.response?.data?.message ||
          'Failed to load your API Network listings'
      );
    }
  }

  async getNetworkStatus(workspaceId) {
    try {
      const response = await apiClient.get(`/workspaces/${workspaceId}/publish-to-network`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return { status: 'none' };
      }
      throw new Error(
        error.response?.data?.error ||
          error.response?.data?.message ||
          'Failed to load network publish status'
      );
    }
  }

  async publishToNetwork(workspaceId, data) {
    try {
      const response = await apiClient.post(
        `/workspaces/${workspaceId}/publish-to-network`,
        data
      );
      return response.data;
    } catch (error) {
      const msg =
        error.response?.data?.error ||
        error.response?.data?.message ||
        'Failed to publish to API Network';
      const err = new Error(msg);
      err.status = error.response?.status;
      err.upgradeRequired = Boolean(error.response?.data?.upgrade_required);
      throw err;
    }
  }

  async unpublishFromNetwork(workspaceId) {
    try {
      const response = await apiClient.delete(
        `/workspaces/${workspaceId}/publish-to-network`
      );
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.error ||
          error.response?.data?.message ||
          'Failed to unpublish from API Network'
      );
    }
  }

  async fetchImportPackage(slug) {
    try {
      const response = await apiClient.get(`${publicApiPath(slug)}/import-package`);
      return response.data;
    } catch (error) {
      const status = error.response?.status;
      if (status === 404) {
        throw new Error('This API is not published or no longer available.');
      }
      throw new Error(
        error.response?.data?.error ||
          error.response?.data?.message ||
          'Failed to load import package'
      );
    }
  }

  async countImport(slug) {
    try {
      const response = await apiClient.post(`${publicApiPath(slug)}/import`);
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.error ||
          error.response?.data?.message ||
          'Failed to record import'
      );
    }
  }
}

const publicApiService = new PublicApiService();
export default publicApiService;
